export default function getDeviceFeature(linkItem) {
  return linkItem && linkItem.dataAttributes && linkItem.dataAttributes['data-device-feature'];
}